// extracted by mini-css-extract-plugin
export default {"BoxFilter":"BoxFilter_BoxFilter__bbVCO","Filterupon":"BoxFilter_Filterupon__syQvh"};